class ArticlesTabs extends HTMLElement {
  constructor() {
    super();
    this.init();
  }
  
  init() {
    this.tabTriggers = this.querySelectorAll('.js-sc-tab-trigger');
    this.tabContents = this.querySelectorAll('.js-sc-tab-wrapper');
    
    // Remove any href attributes from links inside triggers
    this.tabTriggers.forEach((trigger) => {
      const links = trigger.querySelectorAll('a');
      links.forEach((link) => {
        if (link.hasAttribute('href')) {
          link.removeAttribute('href');
        }
        link.style.pointerEvents = 'none';
      });
    });
    
    this.tabTriggers.forEach((trigger) => {
      // Remove any existing event listeners by cloning
      const newTrigger = trigger.cloneNode(true);
      trigger.parentNode.replaceChild(newTrigger, trigger);
      
      // Prevent any default link behavior with capture phase
      newTrigger.addEventListener('click', (e) => {
        e.preventDefault();
        e.stopPropagation();
        e.stopImmediatePropagation();
        const tabId = newTrigger.getAttribute('data-id');
        if (tabId) {
          this.switchTab(tabId);
        }
        return false;
      }, true);
      
      // Also handle keyboard events
      newTrigger.addEventListener('keydown', (e) => {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          e.stopPropagation();
          const tabId = newTrigger.getAttribute('data-id');
          if (tabId) {
            this.switchTab(tabId);
          }
        }
      });
      
      // Also prevent any link clicks inside the trigger
      const links = newTrigger.querySelectorAll('a');
      links.forEach((link) => {
        link.addEventListener('click', (e) => {
          e.preventDefault();
          e.stopPropagation();
          e.stopImmediatePropagation();
          const tabId = newTrigger.getAttribute('data-id');
          if (tabId) {
            this.switchTab(tabId);
          }
          return false;
        }, true);
      });
    });
    
    // Update references after cloning
    this.tabTriggers = this.querySelectorAll('.js-sc-tab-trigger');
    
    // Initialize first active tab on load
    this.initializeActiveTab();
  }
  
  connectedCallback() {
    // Re-initialize when element is connected to DOM
    if (!this.initialized) {
      this.init();
      this.initialized = true;
    }
  }
  
  initializeActiveTab() {
    // First, try to detect active tab from URL
    const urlTag = this.getTagFromURL();
    let activeTabId = null;
    
    if (urlTag) {
      // Map URL tags to tab IDs
      const tagMap = {
        'psi': 'dogs',
        'macke': 'cats',
        'male-zivotinje': 'small-animals',
        'ptice': 'birds',
        'akvaristika': 'aquaristics',
        'teraristika': 'terraristics'
      };
      activeTabId = tagMap[urlTag] || null;
    }
    
    // If no URL tag, find the active trigger from HTML
    if (!activeTabId) {
      const activeTrigger = this.querySelector('.js-sc-tab-trigger.is-active');
      if (activeTrigger) {
        activeTabId = activeTrigger.getAttribute('data-id');
      }
    }
    
    // If still no active tab, default to 'all'
    if (!activeTabId) {
      activeTabId = 'all';
    }
    
    // Activate the tab
    if (activeTabId) {
      this.switchTab(activeTabId);
    }
  }
  
  getTagFromURL() {
    const path = window.location.pathname;
    if (path.includes('/tagged/')) {
      const parts = path.split('/tagged/');
      if (parts.length > 1) {
        return parts[1].split('/')[0];
      }
    }
    return null;
  }

  switchTab(tabId) {
    console.log('Switching to tab:', tabId);
    
    // Map tab IDs to URL tags
    const tabToTagMap = {
      'all': null,
      'dogs': 'psi',
      'cats': 'macke',
      'small-animals': 'male-zivotinje',
      'birds': 'ptice',
      'aquaristics': 'akvaristika',
      'terraristics': 'teraristika'
    };
    
    const tag = tabToTagMap[tabId];
    
    // Update URL based on tab selection
    const currentPath = window.location.pathname;
    let newPath = currentPath;
    
    // Remove existing /tagged/{tag} if present
    if (currentPath.includes('/tagged/')) {
      const basePath = currentPath.split('/tagged/')[0];
      newPath = basePath;
    }
    
    // Add new tag to URL if not "all"
    if (tag) {
      newPath = `${newPath}/tagged/${tag}`;
    }
    
    // Update URL without page reload
    if (newPath !== currentPath) {
      window.history.pushState({}, '', newPath);
      // Trigger a custom event to notify that URL changed
      window.dispatchEvent(new Event('popstate'));
      // Reload the page to get fresh data from Shopify
      window.location.href = newPath;
      return;
    }
    
    // Remove active class from all triggers
    this.tabTriggers.forEach((trigger) => {
      trigger.classList.remove('is-active');
    });

    // Hide all tab contents
    this.tabContents.forEach((content) => {
      content.classList.add('hidden');
      content.classList.remove('is-active');
    });

    // Show selected tab content
    const selectedContent = this.querySelector(`[data-id="${tabId}"].js-sc-tab-wrapper`);
    if (selectedContent) {
      selectedContent.classList.remove('hidden');
      selectedContent.classList.add('is-active');
      console.log('Tab content shown:', tabId);
    } else {
      console.warn('Tab content not found for:', tabId);
    }

    // Add active class to clicked trigger
    const clickedTrigger = this.querySelector(`.js-sc-tab-trigger[data-id="${tabId}"]`);
    if (clickedTrigger) {
      clickedTrigger.classList.add('is-active');
    } else {
      console.warn('Tab trigger not found for:', tabId);
    }
  }
}

customElements.define('articles-tabs', ArticlesTabs);

